export default {
  en: {
    formTitles: {
      create: 'Create Emerging Threat',
      edit: 'Edit Emerging Threat',
      threatName: 'Emerging Threat name',
      threatType: 'What is the type of Emerging Threat?',
      threatEmergedAt: 'When did the Emerging Threat emerge?',
      threatSummary: 'Summary of the Emerging Threat',
      threatGuideLink: 'Add a link to our guide',
      threatQuestions: 'Emerging Threat specific questions',
      question: 'Q.{0}',
      questionText: 'Question text',
      descriptionText: 'Description',
    },
    misc: {
      seeResponsesInGraph: 'See responses in graph',
      threatNamePlaceholder: 'e.g. Log4J',
      threatEmergedAtPlaceholder: 'DD month YYYY, --;--',
      threatGuideLinkPlaceholder:
        'e.g. https://riskledger.com/blog/emerging-threats-in-the-supply-chain',
      threatSummarySuccint: 'Please be as succint as possible',
      cancel: 'Cancel',
      create: 'Create draft',
      error: 'There was an error creating or editing draft Emerging Threat. Please try again.',
      edit: 'Save changes',
      errorFetching: 'There was an error fetching the Emerging Threat. Please try again.',
      publishThreatConfirmTitle: 'Publish Emerging Threat',
      publishThreatConfirmDesc:
        'Publishing an Emerging Threat will make it visible to all organisations and they will also be sent an email.',
    },
    threatTypes: {
      software: 'Software',
      geopolitical: 'Geopolitical',
      ransomware: 'Ransomware',
      esg: 'ESG',
      other: 'Other',
    },
    states: {
      draft: 'Draft',
      published: 'Published',
      active: 'Active',
      inactive: 'Inactive',
    },
    manageButtons: {
      delete: 'Delete',
      publish: 'Publish',
      edit: 'Edit',
      active: 'Switch to active',
      inactive: 'Switch to inactive',
    },
    failMessages: {
      delete: 'Failed deleting Emerging Threat',
      publish: 'Failed publishing Emerging Threat',
      active: 'Failed activating Emerging Threat',
      inactive: 'Failed deactivating Emerging Threat',
    },
    threatList: {
      searchPlaceholder: 'Search',
      filterBy: 'Filter by:',
      sortBy: 'Sort by:',
      noSelection: 'No Emerging Threat selected',
      createdAtDate: 'Creation date',
      software: 'Software',
      geopolitical: 'Geopolitical',
      ransomware: 'Ransomware',
      esg: 'ESG',
      other: 'Other',
      name: 'Name',
      status: 'Status',
      none: 'None',
      create: 'Create Emerging Threat',
    },
  },
};
